<div class="wc-spy-target" [sdSpyTarget]="componentUid"></div>
<sd-title [titleThemesConfig]="brandThemesEnum.brand" [titleLevel]="2" customClass="brand--h3">
  {{ headline }}
</sd-title>
<sd-html style="margin-top: 0.8rem" [html]="subline" />
<div class="c__documents-container">
  <sd-documents [documents]="documents" (downloadedDocument)="onClick($event)" [brand]="brandCorner" />
</div>
<p class="is-caption">
  <sd-html [html]="disclaimer" tag="span" />
</p>
